import React from 'react'
import About from './About'

const Play = () => {
  return (
      <About />
  )
}

export default Play
